

export const statusColours = {
    'light':  'rgba(32,176,223,0.5)',
    'main':   'rgba(35, 152, 190, 1)',
    'dark':   '#146d89',
    'disabled':  'rgba(224, 224, 224, 0.5)',
    'cancelled': 'rgba(117, 117, 117, 0.4)',
    'waiting':  'rgba(117, 117, 117, 0.6)',
    'enrolled': 'rgba(35, 151, 190, 0.6)',
    'partial':  'rgb(174, 233, 252)',
    'completed': 'rgba(35, 151, 190, 1)',
    'deleted':  'rgba(117, 117, 117, 0.6)',
    'warning': 'rgba(117, 117, 117, 0.6)',
    'passed': 'rgba(117, 117, 117, 0.6)',
    'failed': 'rgba(117, 117, 117, 0.6)',
    'expired': 'rgba(117, 117, 117, 0.6)',
    'expiring': 'rgba(117, 117, 117, 0.6)',
    'error': 'rgba(117, 117, 117, 0.6)',
    'mandatory': '#B71B1C',
    'optional': '#F9B205',
};

const chrColourMap = [
    ['A', '#39BC9C'],
    ['B', '#00838F'],
    ['C', '#F1C410'],
    ['D', '#F39C11'],
    ['E', '#3CCC70'],
    ['F', '#32AE60'],
    ['G', '#D35401'],
    ['H', '#3498DB'],
    ['I', '#2980B9'],
    ['J', '#00BFA5'],
    ['K', '#BF392A'],
    ['L', '#9B59B6'],
    ['M', '#8E44AD'],
    ['N', '#BDC3C7'],
    ['O', '#34495E'],
    ['P', '#95A5A6'],
    ['Q', '#7F8C8D'],
    ['R', '#EC86BF'],
    ['S', '#D870AD'],
    ['T', '#F69785'],
    ['U', '#9BA37E'],
    ['V', '#B49255'],
    ['W', '#A94136'],
    ['X', '#795548'],
    ['Y', '#9E9E9E'],
    ['Z', '#212121'],
    ['0', '#8BC34A'],
    ['1', '#00C853'],
    ['2', '#64DD17'],
    ['3', '#AEEA00'],
    ['4', '#33691E'],
    ['5', '#1B5E20'],
    ['6', '#8BC34A'],
    ['7', '#4CAF50'],
    ['8', '#689F38'],
    ['9', '#388E3C'],
    ['_', '#AA00FF'],
    ['-', '#4A148C'],
    ['@', '#9C27B0'],
    [' ', '#E91E63']
];

export const chrColours = new Map(chrColourMap);
